import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';

import { KeywordsContainer } from './Keywords.styled';

export const Keywords = ({ keywordTags }) => {
  return (
    <Box marginBottom={2}>
      <Typography variant="subtitle1" gutterBottom>
        {strings.inventoryProfiles.common.keywords.title}
      </Typography>
      <KeywordsContainer>
        {keywordTags.map(({ id, displayText }) => (
          <Chip key={id} label={displayText} size="small" />
        ))}
      </KeywordsContainer>
    </Box>
  );
};
